
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { LinkCollection } from '../backend/backendapi';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../util/vue-good-table';
import CenterOnParent from '../util/CenterOnParent';
import CollectionDeleteModal from './Configure/CollectionDeleteModal';
import CollectionEditModal from './Configure/CollectionEditModal';
import CollectionPrintModal from './Configure/CollectionPrintModal';
import LinkCollectionStore from '../../stores/LinkCollectionStore';
import Toasted from 'vue-toasted';
import { WindowType } from '../../util';

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

@Component({
  components: {
    CenterOnParent,
    CollectionDeleteModal,
    CollectionEditModal,
    CollectionPrintModal,
    VueGoodTable,
  },
})
export default class Configure extends Vue {
  private readonly store = new LinkCollectionStore();

  get columnsConfig(): any[] {
    return [{
      label: this.$i18n.t('links.linkCollection.model.name').toString(),
      field: (e: LinkCollection) => e.name,
    }, {
      label: this.$i18n.t('links.linkCollection.model.description').toString(),
      field: (e: LinkCollection) => e.description,
    }, {
      label: this.$i18n.t('links.list.actions').toString(),
      field: 'actions',
      width: '9em',
    }];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  async mounted(): Promise<void> {
    await this.store.reload();
  }

  deleteCollection(collection: LinkCollection): void {
    (this.$refs.deleteModal as CollectionDeleteModal).open([this.store.collectionsById.get(collection.id)!]);
  }

  editCollection(collection: LinkCollection): void {
    console.log('edit', collection, this.store.collectionsById.get(collection.id)!);
    (this.$refs.editModal as CollectionEditModal).open(this.store.collectionsById.get(collection.id)!, false);
  }

  getUrl(collection: LinkCollection): string {
    collection = this.store.collectionsById.get(collection.id)!;
    console.log('window.application.baseUrl', window.application.baseUrl);
    return window.application.baseUrl + 'links/' + collection.id;
  }

  newCollection(): void {
    (this.$refs.editModal as CollectionEditModal).open(LinkCollection.fromJS({}), true);
  }

  printQrCollection(collection: LinkCollection): void {
    (this.$refs.printModal as CollectionPrintModal).open([this.store.collectionsById.get(collection.id)!]);
  }
}
